<template>
	<div
		class="flex flex-col gap-12"
		itemscope
		itemtype="https://schema.org/LocalBusiness"
	>
		<div class="flex flex-col gap-3">
			<AtomTitle
				class="mb-4"
				tag="h2"
				size="sm"
			>
				Adres
			</AtomTitle>
			<span itemprop="name">{{ companyData.name }}</span>
			<ul
				class="flex flex-col gap-3 list-none pl-0"
				itemprop="address"
			>
				<li
					itemprop="streetAddress"
					class="pl-0"
				>
					{{ companyData.streetName }} {{ companyData.streetNumber }}
				</li>
				<li class="pl-0">
					<span itemprop="postalCode">
						{{ companyData.zipcode }}
					</span>
					<span>&nbsp;</span>
					<span itemprop="addressLocality">
						{{ companyData.city }}
					</span>
				</li>
			</ul>
		</div>
		<div class="flex flex-col gap-3">
			<AtomTitle
				class="mb-4"
				tag="h2"
				size="sm"
			>
				Contact
			</AtomTitle>
			<ul class="flex flex-col gap-3 pl-0">
				<li
					itemprop="telephone"
					class="flex items-center gap-3 pl-0"
				>
					<AtomFontAwesome
						icon="fa-phone"
						class="w-6 h-6"
					/>
					{{ companyData.phoneNumber }}
				</li>
				<li
					itemprop="email"
					class="flex items-center gap-3 pl-0"
				>
					<AtomLink
						:title="`Verstuur een e-mail naar ${companyData.generalMail}`"
						:url="`mailto:${companyData.generalMail}`"
						@click="trackEmailClick('OrganismFooter_email', 30)"
					>
						<AtomFontAwesome
							icon="fa-envelope"
							class="w-6 h-6"
						/>
						{{ companyData.generalMail }}
					</AtomLink>
				</li>
			</ul>
		</div>
	</div>
</template>

<script lang="ts" setup>
import type { CompanyDataType } from '#base/core/types/CompanyDataType';

defineProps<{
	companyData: CompanyDataType;
}>();

const {
	trackEmailClick,
} = useEventTracking();
</script>
